import styled from "styled-components";

export const GridRadio = styled.div`
  background: var(--white);
  padding: var(--gip);
  height: 100%;
  width: 100%;
  overflow: hidden;

  grid-column: ${props => (
    (props.type === "1/2" && 'span 3')||
    (props.type === "1/3" && 'span 2')||
    (props.type === "2/3" && 'span 4')||
    (props.type === "5/6" && 'span 5')||
    (props.type === "1/6" && 'span 1')||
    (props.type === "1" && 'span 6')
)};
& .swiper {
  width: ${props => (
    (props.type === "1/2" && 'calc(var(--width-main)/2 - var(--grid-c-gap)/2 - var(--gip) * 2)')||
    (props.type === "1/3" && 'calc( var(--width-main)/3 - var(--gip) * 2 - (var(--grid-c-gap) * 2/3))')||
    (props.type === "2/3" && 'calc(var(--width-main)* 2/3 - var(--gip)/2 - var(--grid-c-gap)/2)')||
    (props.type === "5/6" && 'calc(var(--width-main) - var(--gip) * 2 - var(--min-width-gridInput) - var(--grid-c-gap))')||
    (props.type === "1/6" && 'var(--min-width-gridInput)')||
    (props.type === "1" && 'calc(var(--width-main) - var(--gip) * 2)'))
};
  & input:disabled + label {
    color: var(--whisper-btnCalc);
    background-color: var(--whiteSmoke-bgr);
    border: none;
    cursor: default;
    display: none;
    }
}
  & input {
    visibility: hidden;
    height: 1px;
    width: 1px;
    border: 0;
    position: absolute !important;
    }
  & input:checked + label {
    font-family: var(--bold-font-700);
    background-color: var(--tangerine-yellow);
    }
  & input:disabled + label {
      color: var(--whisper-btnCalc);
      background-color: var(--whiteSmoke-bgr);
      border: none;
      cursor: default;
      }

  & fieldset  {
    width: 100%;
    border: none;
    &:disabled {
      color: var(--whisper-btnCalc);
      & .swiper {
        background-color: var(--whiteSmoke-bgr);
        border: none;
        cursor: default;
      }  
      & label {
        background-color: var(--whiteSmoke-bgr);
        border: none;
        cursor: default;
      }  
    }
  }

  & legend {  
    font-size: var(--legend);
    font-family: var(--bold-font-700);
    padding-bottom: var(--lpb);
    overflow: hidden;
    white-space: nowrap; 
    text-overflow: ellipsis;

  } 
  & label {
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: center;  
    text-align: center;
    width: 100%;
    height: var(--height-input);
    cursor: pointer;
    font-size: var(--lable);
    background-color: var(--whiteSmoke-bgr);
    transition: all 0.1s ease-in-out;
    padding: 2px;
    overflow: hidden;
    &:hover {
      background: var(--tangerine-yellow);
    }
    &   .blockflex {
      display: flex;
      flex-direction: column;
      justify-content: space-between;  
  
    }

  }
  @media screen and (max-width: 1399px) {
    & label {
      line-height: 1;
    };
  }

  @media screen and (max-width: 767px) {
    grid-column: ${props => (
      (props.type && 'span 2')
  )};
  & .carousel {width: 343px;}
  & .swiper {
    width: ${props => (
      (props.type === "1/2" && '344px')||
      (props.type === "1/3" && '344px')||
      (props.type === "2/3" && '344px')||
      (props.type === "5/6" && '344px')||
      (props.type === "1" && '344px'))
  };
}
& input:checked + label {
  font-family: var(--primary-font);
  }

}
`;

export const GridInput = styled.div`
background: var(--white);
padding: var(--gip);
height: var(--height-block);
width: 100%;
min-width: var(--min-width-gridInput);

grid-column: ${props => (
  (props.type === "1/2" && 'span 3')||
  (props.type === "1/3" && 'span 2')||
  (props.type === "5/6" && 'span 5')||
  (props.type === "1/6" && 'span 1')||
  (props.type === "1" && 'span 6')
)};

& fieldset {
  border: none;
}
& legend {  
  font-size: var(--legend);
  padding-bottom: var(--lpb, 18px);
  font-family: var(--bold-font-700);
  display: flex;
  justify-content: space-between;
  align-items: end;
  width: 100%;
} 
& input {
  font-size: var(--lable);
  height: var(--height-input);
  width: 100%;
  background-color: var(--whiteSmoke-bgr);
  padding: 0 15px;
  border: 1px solid transparent;
  font-family: var(--primary-font);
  &::placeholder {
    color: var(--dim-grey);
    }
    &:focus {
      border-color: var(--tangerine-yellow);
      outline: none;
    }
  }

  @media screen and (max-width: 767px) {
    grid-column: ${props => (
      (props.type && 'span 2')
    )};
  }
    `;
